import {Language, Schedule} from '@mui/icons-material';
import AbcIcon from '@mui/icons-material/Abc';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EventIcon from '@mui/icons-material/Event';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import MemoryIcon from '@mui/icons-material/Memory';
import NumbersIcon from '@mui/icons-material/Numbers';
import {blue, cyan, green, grey, orange, purple, red} from '@mui/material/colors';

import {API_PARAMETERS_TYPES} from './domain';

const API_PARAMETER_TYPE_UI = {
  Text: {Icon: AbcIcon, color: green[200]},
  Number: {Icon: NumbersIcon, color: purple[300]},
  Date: {Icon: EventIcon, color: blue[500]},
  DateTime: {Icon: Schedule, color: purple[900]},
  DateTimeZone: {Icon: Language, color: cyan[500]},
  Duration: {Icon: HourglassTopIcon, color: orange[500]},
  Logical: {Icon: CheckCircleIcon, color: green[500]},
  Binary: {Icon: MemoryIcon, color: red[500]},
  Any: {Icon: AbcIcon, color: grey[400]}
};

const mapApiParameterTypeToIcon = apiParameterType => {
  return API_PARAMETER_TYPE_UI[apiParameterType] || API_PARAMETER_TYPE_UI[API_PARAMETERS_TYPES.ANY];
};

export {API_PARAMETER_TYPE_UI, mapApiParameterTypeToIcon};
